import { Theme, Tooltip, withStyles } from '@material-ui/core';

export const LightTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#ff7c00',
    boxShadow: theme.shadows[1],
    color: 'white',
    fontFamily: 'DINNextLTPro-Heavy',
    fontSize: 14
  }
}))(Tooltip);
